import { FC } from 'react';
import { GoalTypeDTO } from '../../../types/goalsDTO';
import { RETIREMENT_TAB_MAP } from '../../goals/Retirement/Retirement.constants';
import { ESTATE_PLANNING_TAB_MAP } from '../../goals/EstatePlanning/EstatePlanning.constants';
import { DECUMULATION_TAB_MAP } from '../../goals/Decumulation/Decumulation.constants';

export const GOAL_TAB_MAP: Record<GoalTypeDTO, Record<string, FC>> = {
  [GoalTypeDTO.Retirement]: RETIREMENT_TAB_MAP,
  [GoalTypeDTO.DebtManagement]: {},
  [GoalTypeDTO.Education]: {},
  [GoalTypeDTO.EmergencyFund]: {},
  [GoalTypeDTO.Insurance]: {},
  [GoalTypeDTO.HealthCare]: {},
  [GoalTypeDTO.HomePurchase]: {},
  [GoalTypeDTO.LargePurchase]: {},
  [GoalTypeDTO.EstatePlanning]: ESTATE_PLANNING_TAB_MAP,
  [GoalTypeDTO.Decumulation]: DECUMULATION_TAB_MAP,
};
